import React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import { useSupporterVideos } from '../../../../../../hooks/supporterVoices/supporterVideos';
import { SECTION_ID_MAPPING } from '../../../../../../hooks/useScrollToSection';
import { CreateVideo } from '../CreateVideo';
import { VideoComponent } from '../VideoComponent';
import { ViewPetitionFeed } from '../ViewPetitionFeed';

export const SupporterVoicesVideos: React.FC = () => {
	const {
		data: {
			petition: { id: petitionId, slug },
			supporterVoicesVideos,
		},
	} = usePetitionDetailsPageData();

	const {
		data: { currentlyPlaying, supporterVideos, showCreateVideo },
		actions: { setCurrentlyPlaying, removeVideoFromState },
	} = useSupporterVideos({ supporterVoicesVideos });

	if (supporterVideos.length === 0) {
		return null;
	}

	return (
		<Box id={SECTION_ID_MAPPING.SUPPORTER_VOICES_VIDEOS}>
			<Heading as="h3" sx={{ fontSize: '20', fontWeight: 'normal' }} mt={36} mb={24}>
				<Translate value="corgi.petition_gamma.videos.title" />
			</Heading>
			<Box
				mb={24}
				sx={{
					// This creates a scrolling carousel.
					maxWidth: '100%',
					overflowX: 'auto',
					overflowY: 'hidden',
					position: 'relative',
				}}
			>
				<Flex
					sx={{
						gap: 16,
					}}
				>
					{supporterVideos.map((video) => {
						return (
							<VideoComponent
								video={video}
								currentlyPlaying={currentlyPlaying}
								key={video.id}
								setCurrentlyPlaying={setCurrentlyPlaying}
								removeVideoFromState={removeVideoFromState}
							/>
						);
					})}
					{showCreateVideo && <CreateVideo />}
				</Flex>
			</Box>

			{/* TODO(CHANGE-67840): replace with a check on a boolean set on pageUserData to avoid CLS */}
			<ClientRender>
				<ViewPetitionFeed petitionId={petitionId} slug={slug} />
			</ClientRender>
		</Box>
	);
};
